<template>
  <div :class="$style.configNameCat">
    <p :class="$style.configTitle">
      {{ configurationTitle }}
    </p>
    <p
      v-if="configurationCategories"
      :class="$style.configCategories"
    >
      {{ configurationCategories }}
    </p>
  </div>
</template>

<script>
import { ConfigurationCategoriesConsts, PolicyConsts } from 'client/util/Constants';

const { policyTemplateTypes } = PolicyConsts;

export default {
  name: 'ConfigurationNameCategories',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
    os: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(policyTemplateTypes).includes(value);
      },
    },
  },

  computed: {
    configurationCategories() {
      const { item: { name }, os } = this;
      const match = Object.values(ConfigurationCategoriesConsts[os])
        .find(configuration => configuration.name === name);

      return (match && match.categories && match.categories.join(', ')) || '';
    },

    configurationTitle() {
      const { item: { displayName } } = this;

      return displayName;
    },
  },
};
</script>

<style module>
.configCategories {
  font-size: 12px;
  font-style: italic;
  margin-bottom: 0 !important;
}

.configNameCat .configTitle {
  margin-bottom: 5px;
}
</style>
